import { i18n, TFunction } from 'i18next';

import { iAuthInfo, Me } from '@/types';

export type ChatbaseProps = {
  callback: () => void;
  t: TFunction;
  i18n: i18n;
  authInfo: iAuthInfo;
  me: Me;
};

export const loadChatbase = ({ authInfo, me, callback, t, i18n }: ChatbaseProps) => {
  const CHATBASE_ID = 'WR-GMrZMiBjziaIfCDbyA';

  const token = me.capabilities.chatbaseToken;
  if (token) {
    if (!window.chatbase || window.chatbase('getState') !== 'initialized') {
      window.chatbase = (...args: any) => {
        if (!window.chatbase.q) {
          window.chatbase.q = [];
        }
        window.chatbase.q.push(args);
      };
      window.chatbase = new Proxy(window.chatbase, {
        get(target, prop) {
          if (prop === 'q') {
            return target.q;
          }
          return (...args: any) => target(prop, ...args);
        },
      });
    }
    setTimeout(() => {
      const user_metadata = {
        language: i18n.language,
        cf_gru_id: authInfo.getGroupId(),
        email_r: me.userInfo.email,
        empId: authInfo.getCompanyId(),
        name_r: authInfo.getUserName(),
        roleId: authInfo.getRolId(),
        cf_plan: me.groupInfo.plan,
        cf_grupo_region: me.groupInfo.countryId,
        accountId: me.groupInfo.name,
      };
      const uid = authInfo.getUserId();
      const rootEmail = uid.includes('@') ? uid : `${uid}@old.interno`;
      window.chatbase('identify', {
        token: token,
        user_id: uid,
        email: rootEmail,
        name: uid,
        user_metadata: JSON.stringify(user_metadata),
      });
    }, 500);
    window.chatbase.setInitialMessages([t('Chatbase.hello')]);
    if (!document.getElementById(CHATBASE_ID)) {
      const script = document.createElement('script');
      script.src = 'https://www.chatbase.co/embed.min.js';
      script.id = CHATBASE_ID;
      script.setAttribute('chatbotId', CHATBASE_ID);
      script.setAttribute('domain', 'www.chatbase.co');
      script.defer = true;

      script.onload = () => {
        self.botloaded = true;
        callback && callback();
      };
      document.body.appendChild(script);
    }
  } else {
    console.warn('No se encontró chatbase_token');
  }
};

export const getChatbaseInitData = (me: Me, authInfo: iAuthInfo, t: TFunction, i18n: i18n) => {
  return {
    callback: () => console.info('Chatbase BOT loaded.'),
    t,
    i18n,
    authInfo,
    me,
  };
};
